<template>
    <div class="item-filter-price">
        <div class="item-filter-price__inputs">
            <div class="item-filter-price__slider" v-if="!loading">
                <!--<vue-slider v-model="price"
                            :max="maxValue"
                            :min="minValue"
                            @error="handleSliderError">
                </vue-slider>-->
            </div>
            <div class="item-filter-price__input-wrapper" :style="loading ? 'opacity: 0' : 'opacity: 1'">
                <div class="item-filter-price__input d-flex align-items-center">
                    <span v-if="lang !== 'se'" class="item-filter-price__currency pr-1">{{ activeCurrency }}</span>
                    <input v-model="price[0]" :min="minValue" :max="maxValue" type="number" @blur="checkPriceInputs" :aria-label="$translate('Ceres::Template.itemFilterPriceMin')"/>
                    <span v-if="lang === 'se'" class="item-filter-price__currency pl-1">{{ activeCurrency }}</span>
                </div>
                <span class="item-filter-price__spacer">-</span>
                <div class="item-filter-price__input d-flex align-items-center">
                    <span v-if="lang !== 'se'" class="item-filter-price__currency pr-1">{{ activeCurrency }}</span>
                    <input v-model="price[1]" :min="minValue" :max="maxValue" type="number" @blur="checkPriceInputs" :aria-label="$translate('Ceres::Template.itemFilterPriceMax')"/>
                    <span v-if="lang === 'se'" class="item-filter-price__currency pl-1">{{ activeCurrency }}</span>
                </div>
            </div>
        </div>
        <div class="item-filter-price__button">
            <button type="button"
                    class="btn btn-primary btn-appearance btn-block"
                    :class="{'disabled': isDisabled}"
                    @click="triggerFilter()"
                    :title="$translate('Ceres::Template.itemApply')" :aria-label="$translate('Ceres::Template.itemFilterButton')">
                {{ $translate("Ceres::Template.itemApply") }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import UrlService from "ceres/app/services/UrlService";
import ApiService from "ceres/app/services/ApiService";

import MonetaryFormatter from '~/app/helper/MonetaryFormatter';
import {isNullOrUndefined} from "ceres/app/helper/utils";

export default {

    data() {
        return {
            price: [0, 1500],
            activeCurrency: App.activeCurrency,
            minValue: 0,
            maxValue: 1500,
            loading: true,
            lang: App.language
        };
    },

    mounted() {
        this.loadMaxPrice();

        const urlParams = UrlService.getUrlParams(document.location.search);

        this.priceMin = urlParams.priceMin || "";
        this.priceMax = urlParams.priceMax || "";
    },

    computed: {
            isDisabled() {
                return (this.price[0] === "" && this.price[1] === "") ||
                    (parseInt(this.price[0]) >= parseInt(this.price[1])) ||
                    this.isLoading;
            },
            vatRate() {

                let filtered = App.defaultVatValue.vatRates[0];

                if(!isNullOrUndefined(filtered)) {
                    return parseFloat(filtered.vatRate);
                }

                return undefined;
            },
            ...mapState({
                isLoading: state => state.itemList.isLoading,
                currentCategory: state => state.navigation.currentCategory,
                basket: state => state.basket.data,
                currentPriceType: state => state.localization.currentPriceType
            })
        },

    methods: {
        loadMaxPrice() {

            let that     = this;
            let url      = new URL(window.location.href);
            let facets   = url.searchParams.get('facets');
            let category = '';
            let search   = url.searchParams.get('query');

            if (typeof facets === 'undefined' || facets == null) {
                facets = '';
            } else {
                facets = '&facets=' + facets;
            }

            if (this.currentCategory) {
                category = 'categoryId=' + this.currentCategory.id
            }

            if (typeof search === 'undefined' || search == null) {
                search = '';
            } else {
                search = 'query=' + search;
            }

            ApiService.get(window.location.origin + '/rest/OD3dprimaV2/price-filter?' + search + category + facets).done(response => {

                const urlParams = UrlService.getUrlParams(document.location.search);

                that.minValue = that.roundPrice(Math.floor(response.priceMin + 1), 'ceil');
                that.maxValue = that.roundPrice(Math.ceil(response.priceMax - 1), 'floor');

                if(that.minValue < 0) {
                    that.minValue = 0;
                }

                that.price[0] = that.roundPrice(parseInt(urlParams.priceMin), 'ceil') || that.minValue;
                that.price[1] = that.roundPrice(parseInt(urlParams.priceMax), 'floor') || that.maxValue;

            }).always(() => {
                that.loading = false;
            });
        },

        triggerFilter() {
            if (!this.isDisabled) {
                this.$store.dispatch('selectPriceFacet', {
                    priceMin: this.roundPrice(this.price[0], 'ceil', 'b2c')+'',
                    priceMax: this.roundPrice(this.price[1], 'floor', 'b2c')+'',
                });
            }
        },

        handleSliderError(type) {

            let curPrice = [...this.price]

            switch (type) {
                case 3:
                    curPrice.forEach((val, key) => {
                        if (val < 0) {
                            curPrice[key] = 0;
                        }
                    });
                    this.price = curPrice;
                    break;
                case 4:
                    curPrice.forEach((val, key) => {
                        if (val > this.maxValue) {
                            curPrice[key] = this.maxValue;
                        }
                    });
                    this.price = curPrice;
                    break;
                case 1:
                    console.log('value not allowed!');
                    break;
                case 2:
                    console.log('interval not allowed!');
                    break;
            }
        },
        checkPriceInputs() {

            let val = this.price;

            if (parseInt(val[0]) > parseInt(val[1])) {
                val = [val[1], val[0]];
            }

            this.price = val;
        },
        roundPrice(price, mathFn, type) {

            if(this.currentPriceType !== 'b2b') {
                return price;
            }

            type = type || '';

            if(price <= 0) {
                return price;
            }

            price = eval('Math.'+mathFn)((this.getPrice(price, type) + Number.EPSILON) * 100) / 100;

            return Math.ceil(price - 1);
        },
        getPrice(value, type) {

            if(value <= 0) {
                return value;
            }

            if(!isNullOrUndefined(this.vatRate) && this.vatRate > 0) {

                let vatFactor = (1 + (this.vatRate / 100));

                //use gross value for server request, net price display is completely done in frontend
                if(type === 'b2c' && this.currentPriceType === 'b2b') {
                    return value * vatFactor
                }

                if(this.currentPriceType === 'b2b') {
                    return value / vatFactor;
                }
            }

            return value;
        }
    },

    filters: {
        _currency(value) {
            return new MonetaryFormatter()
                .format(parseInt(value), App.activeCurrency, true);
        }
    }
}
</script>
